import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import { useCustomerReferral } from "../../../services/customer-referral/customer-referral.service";

const AvailableCredits = () => {
  const { getReferredStatus, advocateData, advocateLoading } = useCustomerReferral();

  useEffect(() => {
    getReferredStatus();
  }, []);

  return (
    <Box className="mb-4" sx={{
      "& .MuiFormControl-root": {
        marginBottom: "0rem !important",
      },
    }}>
      <Typography variant="body1" className="!font-bold" gutterBottom>
        Available Credits
      </Typography>
      { advocateLoading? <Skeleton animation="wave" height={80}/> : advocateData && !advocateData.hasReferredFriend ?
        <Box className={"p-3 text-center text-sm border border-taupe-50 bg-taupe-15 rounded-lg"}>
          <h3>No Referral Credits</h3>
          <h3>Start Referring friends to earn credits!</h3>
        </Box> :
        <Box className={"p-3 text-center text-sm border border-taupe-50 bg-white rounded-lg"}>
          <h3 className="font-bold flex justify-center items-center
         text-promo-turquoise"><span><img src="/assets/icons/referral-reward.svg"
              alt="gift wrap image" /> </span>&nbsp;You have successfully referred friends!</h3>
          <p className="mx-4">Ask your hospital team at checkout about any available
            credits that can be used towards your appointment. </p>
        </Box>}

    </Box>
  );
};

export default AvailableCredits;
